import { formatMoney } from '../../../utils/lookahead-common';
import { hhEditor } from '../../../assets/js/field_config/editor-inline-gantt';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const hhWorkTimeCol = (gantt, t) => ({
  name: 'hhWorkTime',
  label: 'HH',
  align: 'center',
  template: (activity) => {
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.hhWorkTime;
    }
    const hasChild = gantt.hasChild(activity.id);
    return t('lang') === 'en'
      ? `
            <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
            color: #121212;">
                ${formatMoney(activity.hhWorkTime, '', 2, '.', ',')}
            </div>
            `
      : `
            <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="${hasChild ? 'font-weight: 600' : 'font-weight: 100'}; 
            color: #121212;">
                ${formatMoney(activity.hhWorkTime, '', 2, ',', '.')}
            </div>
            `;
  },
  data_type: 'number',
  editor: hhEditor,
  hide: !isColumnVisibleByDefault('hhWorkTime'),
  width: '*',
  resize: true,
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → 9', '9 → 1'],
  filterable: true
});

export default hhWorkTimeCol; 